import Lambton from "../assets/images/Lambton-pro.jpg"
import Counseling from "../assets/images/Counseling-Home.png"
import star from "../assets/images/star_home.jpg"
import crudcook from "../assets/images/Ride-Community.jpg"
import circuit from "../assets/images/CircuitVerse.jpg"
import onlinelib from "../assets/images/Online-Library.jpg"
const WB = [
    {
        imgUrl: Lambton, 
        title: "Sarnia-Lambton-EPZ",
        description: "The Website developed conveys a comprehensive overview of the Export Processing Zone plan with respect to “Toyota”, as well as current employment possibilities in the plant. The website is created for the post graduate (MBA) students studying in Lambton University, Canada", 
        skills: "React Js, Node Js, Mongo DB, Expres JS",
        weblink: "https://github.com/bhutani2002/lambton-client",
      },
      {
        imgUrl: Counseling, 
        title: "Student Counseling",
        description: "Gathered all the important government counselling links for the respective states so that a person or student of any state can check for their own and other state's counselling schedule and procedures, with just a click and does not have to wander around different websites to get their desired search.", 
        skills: "HTML, CSS, Node Js, Express",
        weblink: "https://github.com/bhutani2002/Student-Counselling",
      },
      {
        imgUrl: crudcook, 
        title: "Ride Commmunity",
        description: "Building and empowering skateboard communities. Worked on Frontend side with React, Material UI, Ant Design Frontend Libraries on Home page of the website.", 
        skills: "React Js, Bootstrap",
        weblink: "https://ride.community/",
      },
      {
        imgUrl: star, 
        title: "Student Team For Alumni Relations",
        description: "Worked on the enhancement of the website by adding new webpages, responsiveness, plugins, etc. The Alumni Cell of any educational institute has a pre-eminent aspect, to bridge in the gap of connection and communication between its students and the Alumni.",
        skills: "EJS, CSS, JavaScript",
        weblink: "https://github.com/bhutani2002/star_new",
      },
      {
        imgUrl: circuit, 
        title: "CircuitVerse",
        description: "Worked with CircuitVerse organization on Open Source. CircuitVerse is a product developed by students at IIIT-Bangalore. It aims to provide a platform where circuits can be designed and simulated using a graphical user interface.", 
        skills: "HTML, RUBY, Javascript",
        weblink: "https://github.com/CircuitVerse/CircuitVerse/pull/2910",
      },
      {
        imgUrl: onlinelib, 
        title: "Online Library",
        description: "Online book reading platform that delivers the most used words (with number of times), least used terms (with number of times), and document stats for the specific book chosen. It also includes the ability to substitute a certain word with another term of your choice. It also has a toggle button to maximise the reading view according to the reader's preference. The website is completely Responsive.", 
        skills: "HTML, Css, Js",
        weblink: "https://bhutani2002.github.io/OnlineLibrary/",
      },
];

export default WB